import React from "react";
import key_1 from "../assets/about.png";
import key_3 from "../assets/pngtree-realistic-view-of-a-lucky-jack.png";
import toy_train from "../assets/toy-train.png";
import key_4 from "../assets/1.png";
import key_7 from "../assets/111.png";
import Header from "./Header";
import icon_a from "../assets/check.png"
import { Helmet } from "react-helmet-async";
import additional from "../assets/additional.png";
import urban1 from "../assets/urban-fighter/1.png";
import urban2 from "../assets/urban-fighter/2.png";
import urban3 from "../assets/urban-fighter/3.png";
import urban4 from "../assets/urban-fighter/44.png";

import fighter1 from "../assets/urban-fighter/Urban Fighter/1.png";
import fighter2 from "../assets/urban-fighter/Urban Fighter/2.png"
import fighter3 from "../assets/urban-fighter/Urban Fighter/3.png"
import fighter4 from "../assets/urban-fighter/Urban Fighter/4.png"

const UrbanFighter = () => {
  const imageData = [
  {
    src: fighter1,
    text: "Urban Fighter Slot Machine Reel Theme",
  },
  {
    src: fighter2,
    text: "Urban Fighter Slot Machine Super Win Feature",
  },
  {
    src: fighter3,
    text: "Urban Fighter Slot Machine Mega Win Feature",
  },
  {
    src: fighter4,
    text: "Urban Fighter Slot Machine Big Win Feature",
  },
];
  return (
    <div>
      <Helmet>
        <title>Urban Fighter Slot Game Development | Fusion Spin</title>
        <meta name="description" content="Unleash the thrill of urban combat with Fusion Spin's Urban Fighter slot game development." />
        <meta name="keywords" content="Urban Fighter slot game, combat slot games, urban-themed slot development, slot game outsourcing, Fusion Spin" />
      </Helmet>

      <Header />

      {/* Intro Section */}
      <section className="bg-white py-10 px-4 md:px-10 lg:px-16 xl:px-48 mx-auto">
        <h2 className="text-3xl md:text-4xl text-left font-extrabold py-2 poppins-font">Urban Fighter</h2>
        <hr className="w-14 bg-black h-[2px] border-none shadow-lg mb-7 hidden sm:block" />
        <p className="text-gray-500 font-medium text-lg poppins-font2 text-start leading-relaxed">
        Step into the gritty, action-packed world of Urban Fighter Brawl, a high-energy 5x3 reel slot game where every spin is a battle for victory. Inspired by the thrill of street fights, this game brings a unique twist to slot gameplay with its battle feature, wild multipliers, and mystery symbols. Get ready to brawl your way to big wins and experience the adrenaline of the urban arena!
        </p>
      </section>

      {/* Main Game Features */}
      <div className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-center">
          <img src={urban1} alt="Urban Fighter Slot Main Game Features" 
          title="Urban Fighter Slot Main Game Features"
          className="max-w-full h-auto" />
        </div>
        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">Main Game Features</h2>
          <p className="text-gray-400 poppins-font2 text-base leading-relaxed mb-4">
            The core of Urban Fighter Brawl revolves around its battle feature, where two symbols face off on every spin. Here’s how it works: <br /> <br />
            <span className="font-bold text-gray-500">Brawl Feature:</span> On each spin, two symbols from the five face card symbols are randomly selected to battle it out. The winning symbol converts the losing one, creating matching symbols and boosting your chances of big payouts.
          </p>
        </div>
      </div>

      {/* Mystery Symbols */}
      <div className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col-reverse lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-start">
          <h2 className="text-4xl font-bold mb-4 poppins-font text-start">Mystery Symbols</h2>
          <p className="text-gray-400 poppins-font2 text-base leading-relaxed">
          Mystery symbols add an element of surprise to the game, keeping you on the edge of your seat: <br /> <br />
          <span className="font-bold text-gray-500">Mystery Symbols:</span> These symbols appear randomly on the reels and transform into one of the two battling symbols, increasing your chances of creating winning combinations.Will they turn into the winning symbol and help you dominate the reels? There’s only one way to find out!
          </p>
        </div>
        <div className="lg:w-1/2 text-center">
          <img src={urban2} alt="Urban Fighter Slot Mystery Symbols" 
          title="Urban Fighter Slot Mystery Symbols"
          className="max-w-full h-auto" />
        </div>
      </div>

      {/* Wild Multipliers */}
      <div className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col lg:flex-row items-center justify-between gap-8">
        <div className="lg:w-1/2 text-center">
          <img src={urban3} alt="Urban Fighter Slot Wild Symbols"
          title="Urban Fighter Slot Wild Symbols"
          className="max-w-full h-auto" />
        </div>
        <div className="lg:w-1/2 text-start">
          <h2 className="text-4xl font-bold mb-4 poppins-font text-start">Wild Multipliers</h2>
          <p className="text-gray-400 poppins-font2 text-base leading-relaxed">
            The wild symbols in Urban Fighter Brawl are not just ordinary wilds—they’re your ultimate allies in the fight for big wins! <br /> <br />
            <span className="font-bold text-gray-500">Wild Multiplier Boost:</span> Wild symbols can appear randomly and apply a multiplier to the winning symbol, boosting your payout.The multiplier value varies, adding an extra layer of excitement to every spin.
          </p>
        </div>
      </div>

      {/* Additional Features */}
      <div className="container mx-auto px-4 md:px-10 lg:px-16 xl:px-48 py-16 flex flex-col lg:flex-row-reverse items-center justify-between gap-8">
        <div className="lg:w-1/2 text-center">
          <img src={additional} alt="Grand Jackpot" 
          title="Grand Jackpot
"
          className="max-w-full h-auto" />
        </div>
        <div className="lg:w-1/2 text-start">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4 poppins-font">Additional Features</h2>
          <p className="text-gray-400 poppins-font2 text-base leading-relaxed mb-4">King of the Jungle is packed with even more features to keep the excitement flowing:</p>
         <ul className="list-disc space-y-3 text-gray-400 poppins-font2 text-base leading-relaxed">
  <li><span className="font-bold text-gray-500">Nudge:</span> Get an extra nudge to align the reels perfectly for a winning combination.</li>
  <li><span className="font-bold text-gray-500">Skill Games:</span> Test your skills and unlock bonus rewards with interactive mini-games.</li>
  <li><span className="font-bold text-gray-500">Pre-Reveal:</span> Peek at what is coming next and strategist your spins for maximum wins.</li>
  <li><span className="font-bold text-gray-500">Link Jackpot:</span> Connect with other players and compete for a shared jackpot prize.</li>
  <li><span className="font-bold text-gray-500">Progressive Jackpot:</span> Dream big! The progressive jackpot grows with every spin, offering life-changing rewards to lucky players.</li>
</ul>

        </div>
      </div>

      {/* Why Choose Section */}
      <div className="bg-white py-20 px-4 md:px-10 lg:px-16 xl:px-48">
        <div className="flex flex-col lg:flex-row-reverse gap-16">
          <div className="lg:w-1/2 flex justify-center">
            <img src={urban4} alt="Urban Fighter Slot Game and Super Jackpot Feature
"
            title="Urban Fighter Slot Game and Super Jackpot Feature
"
            className="w-full max-w-md object-contain" />
          </div>
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-black text-start">Why Choose Urban Fighter Slots?</h2>
            <div className="space-y-6">
              {[
                { title: "Unique Battle Mechanic", text: " The battle feature adds a thrilling twist to traditional slot game play, making every spin unpredictable and exciting." },
                { title: "Wild Multipliers", text: " Boost your wins with wild multipliers that can turn even small victories into massive payouts." },
                { title: "Mystery Symbols", text: " Keep the excitement alive with mystery symbols that can transform into winning symbols at any moment." },
                { title: "Immersive Theme", text: "The urban fighter theme, complete with gritty visuals and intense sound effects, pulls you into the heart of the action." },
              ].map((item, idx) => (
                <div key={idx}>
                  <div className="flex items-center mb-2">
                    <img src={icon_a} alt="" className="w-6 h-6 mr-2" />
                    <h3 className="text-xl font-semibold text-black poppins-font">{item.title}</h3>
                  </div>
                  <p className="text-gray-500 poppins-font2 text-start text-base leading-relaxed">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Gallery */}
      <div className="bg-gray-100 py-20">
        <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 px-4 md:px-10 xl:px-48">
       {imageData.map((item, idx) => (
  <div key={idx} className="bg-white rounded-lg shadow-md">
    <img
      src={item.src}
      alt={item.text}
      title={item.text}
      className="w-full rounded-md"
    />
  </div>
))}
        </div>
      </div>

      {/* Youtube Section */}
      <div className="bg-white py-20">
        <div className="container mx-auto px-4 md:px-10 xl:px-48">
          <h2 className="text-start font-semibold text-2xl poppins-font">Games</h2>
          <hr className="w-14 bg-black h-[2px] border-none shadow-lg my-4 hidden sm:block" />
          <div className="aspect-video w-full">
            <iframe
              src="https://www.youtube.com/embed/YOUR_YOUTUBE_VIDEO_ID"
              title="Urban Fighter Gameplay"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Game List */}
      <div className="bg-white py-20">
        <div className="container mx-auto px-4 md:px-10 xl:px-48 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-8">
          {["Fruit Juice", "King of the Jungle", "Urban Fighter", "Fruit Juice", "Fruit Juice", "Fruit Juice", "Fruit Juice"].map((name, idx) => (
            <div key={idx} className="text-center">
              <img src={key_7} alt={`Game ${idx}`} className="w-36 h-36 mx-auto mb-4" />
              <p className="text-lg font-bold text-gray-500 poppins-font">{name}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UrbanFighter;
